import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SeraTableLoader } from '../sera-table/models/SeraTableLoader';
import { SearchUser } from 'src/app/user-admin/user/models/SearchUser';
import { UserSimpleSearchParams } from 'src/app/user-admin/user/models/UserSimpleSearchParams';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { addFavoriteUser, removeFavoriteUser } from 'src/app/analysis/state/analysis.actions';
import { UserFavoriteDTO } from 'src/app/user-admin/user/models/UserFavoriteDTO';

@Component({
    selector: 'sera-user-search-popup',
    templateUrl: './sera-user-search-popup.component.html',
    styleUrls: ['./sera-user-search-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraUserSearchPopupComponent implements OnChanges {
    constructor(private readonly formBuilder: UntypedFormBuilder, private readonly store: Store) {}

    ngOnChanges(_: SimpleChanges): void {
        this.userSearchTableContent = {
            ...this.userSearchTableContent,
            data: [...this.userSearchTableData]
        };
    }

    @Input()
    displayUserSearchPopup: boolean = false;

    @Input()
    userSearchTableData: SearchUser[] = [];

    @Input()
    isTableLoading: boolean = false;

    @Output()
    searchUserEvent: EventEmitter<UserSimpleSearchParams> = new EventEmitter();

    @Output()
    selectUserEvent: EventEmitter<SearchUser> = new EventEmitter();

    @Output()
    closePopupEvent: EventEmitter<boolean> = new EventEmitter();

    userSearchParamsForm: UntypedFormGroup = this.formBuilder.group({
        lastName: [null],
        firstName: [null],
        plantCCDC: [null],
        mail: [null],
        qNumber: [null],
        restrictSearchSeraUsers: new FormControl(true, { nonNullable: true })
    });

    selectUser = (obj: { rowData: SearchUser }) => {
        this.selectUserEvent.emit(obj.rowData);
        this.closeDialog();
    };

    addAndRemoveFavoriteUser = (obj: { rowData: SearchUser }) => {
        const userFavoriteParams: UserFavoriteDTO = {
            favoriteQNumber: obj.rowData.qNumber
        };
        if (!this.isFavorite(obj.rowData)) {
            this.store.dispatch(addFavoriteUser({ params: userFavoriteParams }));
        } else {
            this.store.dispatch(removeFavoriteUser({ params: userFavoriteParams }));
        }
    };

    isFavorite = (rowData: any) => {
        return rowData.isFavorite;
    };

    userSearchTableContent: SeraTableLoader = {
        tableTitle: '',
        data: [],
        cols: [
            {
                field: 'firstName',
                header: 'PAGE.USERADMIN.FIRSTNAME.LBL',
                width: 200,
                maxWidth: 200,
                colSpan: '1'
            },
            {
                field: 'lastName',
                header: 'PAGE.USERADMIN.LASTNAME.LBL',
                width: 200,
                maxWidth: 200,
                colSpan: '1'
            },
            {
                field: 'plantCcDcList',
                header: 'PAGE.MASTERDATA.PLANT_CC_DC.LBL',
                width: 300,
                maxWidth: 300,
                colSpan: '1'
            },
            {
                field: 'mail',
                header: 'PAGE.USERADMIN.EMAIL.LBL',
                width: 200,
                maxWidth: 200,
                colSpan: '1'
            },
            {
                field: '',
                disableSort: true,
                header: '',
                width: 75,
                colSpan: '1',
                type: 'buttons',
                seraButtons: [
                    {
                        type: 'toggleButton',
                        action: this.addAndRemoveFavoriteUser,
                        onIcon: 'ci ci-star_fill',
                        offIcon: 'ci ci-favorite',
                        isToggled: this.isFavorite,
                        buttonClass: 'sera-table-toggle-square-button'
                    },
                    {
                        label: 'PAGE.USERSEARCH.SELECT_USER',
                        type: 'iconButton',
                        action: this.selectUser,
                        defaultIconClass: 'check'
                    }
                ]
            }
        ]
    };

    closeDialog() {
        this.closePopupEvent.emit();
        this.userSearchParamsForm.reset();
    }

    searchUser() {
        this.searchUserEvent.emit(this.getUserSimpleSearchParams());
    }

    getUserSimpleSearchParams(): UserSimpleSearchParams {
        return {
            ...this.userSearchParamsForm.value,
            plantCCDC: this.userSearchParamsForm.value.plantCCDC ? '*' + this.userSearchParamsForm.value.plantCCDC + '*' : null
        } as UserSimpleSearchParams;
    }
}
